import Cookies from "js-cookie";

export default {
  //   /​**​
  //    * 设置 Cookie
  //    * @param {string} name 名称
  //    * @param {string} value 值
  //    * @param {object} options 选项
  //    */
  set(name, value, options = {}) {
    const defaultOptions = {
      expires: 7, // 7天过期
      path: "/",
      sameSite: "Lax",
      secure: process.env.NODE_ENV === "production",
    };

    Cookies.set(name, value, { ...defaultOptions, ...options });
  },

  //   /​**​
  //    * 获取 Cookie
  //    * @param {string} name 名称
  //    * @returns {string|undefined} Cookie 值
  //    */
  get(name) {
    return Cookies.get(name);
  },

  //   /​**​
  //    * 获取 JSON 格式的 Cookie
  //    * @param {string} name 名称
  //    * @returns {object|null} JSON 对象
  //    */
  getJSON(name) {
    return Cookies.getJSON(name);
  },

  //   /​**​
  //    * 删除 Cookie
  //    * @param {string} name 名称
  //    * @param {object} options 选项
  //    */
  remove(name, options = {}) {
    const defaultOptions = {
      path: "/",
    };

    Cookies.remove(name, { ...defaultOptions, ...options });
  },

  //   /​**​
  //    * 获取认证 Token
  //    * @returns {string|null} Token 值
  //    */
  getToken() {
    return this.get("token");
  },

  //   /​**​
  //    * 设置认证 Token
  //    * @param {string} token Token 值
  //    * @param {object} options 选项
  //    */
  setToken(token, options = {}) {
    this.set("token", token, options);
  },

  //   /​**​
  //    * 删除认证 Token
  //    */
  removeToken() {
    this.remove("token");
  },

  //   /​**​
  //    * 获取用户信息
  //    * @returns {object|null} 用户信息对象
  //    */
  getUserInfo() {
    return this.getJSON("userInfo");
  },

  //   /​**​
  //    * 设置用户信息
  //    * @param {object} userInfo 用户信息对象
  //    * @param {object} options 选项
  //    */
  setUserInfo(userInfo, options = {}) {
    this.set("userInfo", JSON.stringify(userInfo), options);
  },

  removeUserInfo() {
    this.remove("userInfo");
  },

  getLanguage() {
    return this.get("language") || "zh-CN";
  },

  setLanguage(lang) {
    this.set("language", lang);
  },
};
